


// import React, { useState } from "react";
// import React from 'react';
import {Link} from 'react-router-dom';
import "./novaconta.css";
import AgendexLogo from '../../Assets/agendex/iconLogoAgendex.png'

function NovaContaModal(){
    var ano = new Date().getFullYear();
    return <section id="novacontamodal">
        <div className="container login-container">
            <div className="row">
                <div className="col-md-6 login-form-1">
                    <h3>Nova Conta Cliente</h3>
                        <form action="">
                            <div className="form-group text-right">
                                <Link to="/app/novaconta/cliente" style={{ textDecoration: 'none' }} type="button" className="btnSubmit" id="novacontacliente" name="novacontacliente" value="Criar">Criar</Link>
                            </div>
                            <div className="col-lg-6">

                            </div>
                            {/* <div className="form-group text-right">
                                <Link to="/app/resetsenha" className="btnForgetPwd" value="Login">Esqueceu a senha?</Link>
                            </div> */}
                        </form>
                </div>
                <div className="col-md-6 login-form-2">
                    <div className="login-logo">
                        <img src={AgendexLogo} alt="Agendex Logo"/>
                    </div>
                    <h3>Nova Conta Prestador</h3>
                    <form action="">
                        <div className="form-group text-right">
                            <Link to="/app/novaconta/prestador" style={{ textDecoration: 'none' }} type="button" className="btnSubmit" id="novacontaprestador" name="novacontaprestador" value="Login">Cadastrar</Link>
                        </div>
                        {/* <div className="form-group text-right">
                            <Link to="/app/resetsenha" className="btnForgetPwd" value="Login">Esqueceu a senha?</Link>
                        </div> */}
                    </form>
                </div> 
            </div>
            <Link to="/app/resetsenha" className="btnForgetPwd" value="Login">Esqueceu a senha?</Link>
            <div className="textoRodape" >
                <Link to="/app/login">Já tenho conta. Toque aqui para fazer login.</Link>
                <p > Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
            </div>
        </div>
    </section>
    }
    
    export default NovaContaModal;
